import { useEffect, useState } from 'react';

import { useGetApiV5FirmsRequests } from '@liscio/api';
import { Skeleton, Typography } from '@liscio/ui';

import { useRequestFilterStore } from 'modules/requests/hooks/useRequestFilterStore';

interface TotalCountHeaderProps {
  totalFilteredEntries: number | undefined | null;
  isFilteredQueryLoading: boolean;
}

export const TotalCountHeader = ({
  isFilteredQueryLoading,
  totalFilteredEntries,
}: TotalCountHeaderProps) => {
  const [label, setLabel] = useState('');
  const { bulkSendModeOn, filters } = useRequestFilterStore();
  const { data: noFiltersData } = useGetApiV5FirmsRequests(
    { per_page: 1 },
    {
      query: {
        queryKey: ['requests-total-counts'],
        staleTime: Infinity, // never refetch
        cacheTime: Infinity,
        retry: false,
      },
    }
  );

  const totalEntriesCount = noFiltersData?.meta?.total_entries;
  const shouldDisplaySkeleton = !label;
  const textColor = isFilteredQueryLoading ? 'GrayText' : 'textPrimary';

  useEffect(() => {
    if (
      typeof totalFilteredEntries === 'number' &&
      typeof totalEntriesCount === 'number'
    ) {
      const newLabel = bulkSendModeOn
        ? `Bulk edit ${filters.status === 'draft' ? 'drafts ' : ''}(${
            totalFilteredEntries || '0'
          })`
        : `Requests (${totalFilteredEntries || '0'} of ${
            totalEntriesCount || '0'
          })`;

      setLabel(newLabel);
    }
  }, [totalFilteredEntries, totalEntriesCount, bulkSendModeOn, filters.status]);

  return (
    <Typography pl={1} variant="h2" color={textColor}>
      {!shouldDisplaySkeleton && label}
      {shouldDisplaySkeleton && <Skeleton data-testid="skeleton" width={500} />}
    </Typography>
  );
};
